export default "__VITE_ASSET__5031bde4__"